<template>
    <div class="page">
        <div class="title">
            设置值班老师
            <a-popover arrow-point-at-center placement="bottomLeft">
                <template slot="content">
                    <p>仅允许设置本校老师；</p>
                    <p>每日12点前可更换当日值班老师；</p>
                    <p>修改值班老师后，只会影响后续的值班老师安排；</p>
                    <p>值班老师不需要考勤，会自动记录考勤记录；</p>
                    <p>每日最多设置三名值班老师。</p>
                </template>
                <a-icon class="icon-circle" type="question-circle" />
            </a-popover>
        </div>
        <div class="content">
            <div class="item" v-for="(item, index) in list" :key="index">
                <div class="item-title">{{ item.day }} ：</div>
                <div class="item-content">
                    <a-select showSearch allowClear placeholder="请选择" @change="handleChange($event, index)"
                        @search="searchTeacher" :filterOption="filterOption"
                        :notFoundContent="searchTeacherLoading ? undefined : '没有查询结果'" :value="item.teacherUserIds"
                        style="width: 350px;" mode="multiple">
                        <a-spin v-if="searchTeacherLoading" slot="notFoundContent" size="small" />
                        <a-select-option v-for="(item2, index) in teacherList" :key="index" :value="item2.userId">
                            {{ item2.nickName }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
        </div>
        <a-button @click="submit" type="primary" class="save">保存</a-button>
    </div>
</template>
<script>
import Vue from 'vue'
import teacher from '../../api/teacher'
export default {
    name: 'dutyTeacher',
    data() {
        return {
            list: [
                { day: '周一', teacherUserIds: [], weekday: 1 },
                { day: '周二', teacherUserIds: [], weekday: 2 },
                { day: '周三', teacherUserIds: [], weekday: 3 },
                { day: '周四', teacherUserIds: [], weekday: 4 },
                { day: '周五', teacherUserIds: [], weekday: 5 },
                { day: '周六', teacherUserIds: [], weekday: 6 },
                { day: '周日', teacherUserIds: [], weekday: 7 },
            ],
            teacherList: [],
            searchTeacherLoading: false,
        }
    },
    created() {
        this.searchTeacher()
        this.getDutySetting()
    },
    methods: {
        getDutySetting(){
            teacher.getDutyTeacher().then(res=>{
                console.log(res,'res')
                res.data.forEach(item => {
                    this.list.find(ele=>ele.weekday == item.weekday).teacherUserIds = item.teacherUserIds
                });
            })
        },
        //搜索老师
        searchTeacher(val = '') {
            console.log('searchTeacher', val)
            this.teacherContent = val
            this.searchTeacherLoading = true
            let req = {
                pageSize: 500,
                keyword: val.trim(),
            }
            teacher.getTeacherList(req).then((res) => {
                console.log(res, 'res')
                this.searchTeacherLoading = false
                this.teacherList = res.data.list
            })
        },
        filterOption(value, option) {
            return option.componentOptions.children[0].text.indexOf(value) >= 0
        },
        handleChange(event, index) {
            if (event.length > 3) {
                return this.$message.warn('每日最多设置三名值班老师')
            }
            this.list[index].teacherUserIds = event
        },
        submit() {
            let temp = this.list.map(item => {
                return {
                    schoolId : Vue.ls.get('schoolId'),
                    weekday: item.weekday,
                    teacherUserIds: item.teacherUserIds
                }
            })
            console.log(temp)
            teacher.updateDutyTeacher(temp).then(res=>{
                this.$message.success('保存成功')
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.page {
    margin: 20px;
    padding: 40px;
    height: calc(100vh - 109px);
    background-color: #fff;
}

.title {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 44px;
}

.item {
    display: flex;
    margin-top: 20px;
    align-items: center;

    .item-content {
        margin-left: 20px;
    }
}

.save {
    margin-top: 50px;
}
</style>